import { PAGE_TYPE } from '@sravni/ugc/lib/organizations/constants';

import { ReviewType } from '../helpers/reviews';

export const ratingsListUrl = (type: PAGE_TYPE, reviewType: ReviewType) => {
  const { listTypeUrl } = reviewType;
  switch (type) {
    case PAGE_TYPE.Shkola:
      return '/kursy/rating/';
    case PAGE_TYPE.Zaimy:
      return '/zaimy/rating-mfo/?userRatingType=all';
    default:
      return `/${listTypeUrl}/rating/klientskij/`;
  }
};
